import {cn} from '../classname';

export const cnEditorComponent = cn('editor-component');
